export default {"src":"/_next/static/media/fast.c4c0cdc9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};